import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BatchDetail } from '../../../model/Venture';
import HttpClient, { Callback, CallbackType, ExtraAction } from '../api';

const INITIAL_STATE: Array<BatchDetail> = [];

export const slice = createSlice({
  name: 'batchs',
  initialState: INITIAL_STATE,
  reducers: {
    addBatch: (state, { payload }: PayloadAction<BatchDetail>) => {
      console.log('batch', payload);
      return [...state, { ...payload }];
    },
  },
});

export const { addBatch } = slice.actions;

export const findVentureBatchById = (
  batchId: number,
  customerId?: number | undefined | null,
  extraActions?: Array<ExtraAction>,
  customErrorsMap = new Map<number, string>(),
  callbacks: Array<Callback> = [
    {
      type: CallbackType.SUCCESS,
      function: () => console.log('findVentureBatchById success'),
      full: false,
    },
  ],
) => {
  return HttpClient.findVentureBatchById(
    batchId,
    customerId,
    addBatch.type,
    customErrorsMap,
    extraActions,
    callbacks,
  );
};

export const sendIntention = (
  data: any,
  callbacks: Array<Callback> = [
    {
      type: CallbackType.SUCCESS,
      function: () => console.log('sendIntention success'),
      full: false,
    },
  ],
  extraActions?: Array<ExtraAction>,
  customErrorsMap = new Map<number, string>(),
) => {
  return HttpClient.sendIntention(data, customErrorsMap, extraActions, callbacks);
};

export const sendReservation = (
  data: any,
  callbacks: Array<Callback> = [
    {
      type: CallbackType.SUCCESS,
      function: () => console.log('sendReservation success'),
      full: false,
    },
  ],
  extraActions?: Array<ExtraAction>,
  customErrorsMap = new Map<number, string>(),
) => {
  return HttpClient.sendReservation(data, callbacks, customErrorsMap, extraActions);
};

export const sendSimulation = (
  data: any,
  callbacks: Array<Callback> = [
    {
      type: CallbackType.SUCCESS,
      function: () => console.log('sendSimulation success'),
      full: false,
    },
  ],
  extraActions?: Array<ExtraAction>,
  customErrorsMap = new Map<number, string>(),
) => {
  return HttpClient.sendSimulation(data, customErrorsMap, extraActions, callbacks);
};

export default slice.reducer;
